// Кампании: список, создание, вступление, видимость.
// Вынесено из api.ts (Фаза 1, разбор клиента по доменам).

import { request } from "./client";
import { type CampaignStatus } from "./common";
import { type MediaAsset } from "./media";

export type CampaignMemberRole = "OWNER" | "PLAYER";
export interface Campaign {
  id: string;
  title: string;
  status: CampaignStatus;
  inviteCode?: string;
  memberRole: CampaignMemberRole;
  memberCount: number;
  unreadCount: number;
  hasUnread: boolean;
  languageCode?: string;
  publicVisible: boolean;
  coverImage?: MediaAsset;
  createdAt: string;
}
export interface PublicCampaign {
  id: string;
  title: string;
  status: CampaignStatus;
  memberCount: number;
  maxPlayers: number;
  slotsLeft: number;
  ownerDisplayName: string;
  createdAt: string;
}
export type SetupCampaign = Campaign

export const campaignApi = {
  campaigns: () => request<Campaign[]>("/api/campaigns"),
  publicCampaigns: () => request<PublicCampaign[]>("/api/campaigns/public"),
  createCampaign: (title: string, publicVisible: boolean) =>
    request<Campaign>("/api/campaigns", {
      method: "POST",
      body: JSON.stringify({ title, publicVisible }),
    }),
  joinCampaign: (inviteCode: string) =>
    request<Campaign>("/api/campaigns/join", {
      method: "POST",
      body: JSON.stringify({ inviteCode }),
    }),
  joinPublicCampaign: (campaignId: string) =>
    request<Campaign>(`/api/campaigns/${campaignId}/join-public`, {
      method: "POST",
    }),
  updateCampaignVisibility: (campaignId: string, publicVisible: boolean) =>
    request<Campaign>(`/api/campaigns/${campaignId}/visibility`, {
      method: "PUT",
      body: JSON.stringify({ publicVisible }),
    }),
};
